import React from 'react'

import {createSvgIcon} from './utils'

export default createSvgIcon(
  <React.Fragment>
    <circle cx="12" cy="12.501" r="10" fill="#333333" />
    <path d="M13.8494 17.5009H11.8474V9.52089L8.92139 11.6489V9.75889L12.0714 7.46289H13.8494V17.5009Z" fill="white" />
  </React.Fragment>,
  'AddressPinIcon',
)
